import React from "react";
import { Pagination } from "../../../components/ui/Table/Pagination/Pagination";
import Modal from "../../../components/ui/Modal/Modal";
import { SaveIcon } from "../../../assets/icons";
import "./Table.css";

const row = [
  {
    a: 1,
    b: 12345678912,
    c: "Categoryname",
    d: (
      <div>
        입력사항.입력사항.입력사항.
        <br />
        입력사항.입력사항.입력사항…
      </div>
    ),
    e: (
      <div>
        입력사항.입력사항.입력사항.
        <br />
        입력사항.입력사항.입력사항…
      </div>
    ),
    f: "S123456C",
    g: 20,
    h: 110,
    i: 110,
    j: 20,
    k: 10,
    l: 10,
    m: 10,
    n: 10,
    o: 10,
    p: 10,
    q: 10,
    r: 10,
    s: 10,
  },
  {
    a: 2,
    b: 12345678912,
    c: "Categoryname",
    d: (
      <div>
        입력사항.입력사항.입력사항.
        <br />
        입력사항.입력사항.입력사항…
      </div>
    ),
    e: (
      <div>
        입력사항.입력사항.입력사항.
        <br />
        입력사항.입력사항.입력사항…
      </div>
    ),
    f: "S123456C",
    g: 20,
    h: 110,
    i: 110,
    j: 20,
    k: 10,
    l: 10,
    m: 10,
    n: 10,
    o: 10,
    p: 10,
    q: 10,
    r: 10,
    s: 10,
  },
];

const StatisticsTable = (props) => {
  const { isSecondTab, isThirdTab } = props;
  return (
    <div>
      <div className="mt-3 flex justify-center overflow-auto">
        <Pagination position="justify-end mr-3" />
        <div className="flex-none">
          <Modal
            hasCancel={false}
            description="다운로드 되었습니다."
            onSubmit={() => {}}
          >
            <button className="px-[10px] py-[5px] border border-[#cccccc] rounded-[4px] text-[#333333]">
              <div className="flex items-center gap-2">
                <SaveIcon />
                엑셀 저장
              </div>
            </button>
          </Modal>
        </div>
      </div>
      <div className="overflow-auto Container mt-4 Flipped">
        <div id={"style-2"} className="Content">
          <table className="w-full whitespace-nowrap  Content2 table-auto">
            <thead>
              <tr className="bg-input-grey">
                <th rowSpan={3} className="border border-primary-grey w-12">
                  번호
                </th>
                <th
                  colSpan={5}
                  rowSpan={2}
                  className="border-r border border-r-[#7a7a7a] border-primary-grey"
                >
                  상품 정보
                </th>
                {isThirdTab ? null : (
                  <th
                    colSpan={13}
                    className="border-r border border-r-[#7a7a7a] py-2 border-primary-grey"
                  >
                    재고현황
                  </th>
                )}

                {isSecondTab && (
                  <th colSpan={19} className="border py-2 border-primary-grey">
                    상품 판매현황
                  </th>
                )}
              </tr>
              <tr className="bg-input-grey">
                {isThirdTab ? null : (
                  <>
                    <th colSpan={3} className="border py-2 border-primary-grey">
                      총 입고현황
                    </th>
                    <th colSpan={6} className="border border-primary-grey">
                      총 출고현황
                    </th>
                    <th colSpan={3} className="border border-primary-grey">
                      총 조정현황
                    </th>
                    <th
                      rowSpan={2}
                      className="border-r px-4 border border-r-[#7a7a7a] border-primary-grey"
                    >
                      현재 재고수량
                    </th>
                  </>
                )}

                {isSecondTab && (
                  <>
                    <th
                      colSpan={4}
                      className="border-r border py-2 border-primary-grey"
                    >
                      상품 금액
                    </th>
                    <th
                      colSpan={4}
                      className="border-r border py-2 border-primary-grey"
                    >
                      총 결제완료
                    </th>
                    <th
                      colSpan={3}
                      className="border-r border py-2 border-primary-grey"
                    >
                      총 환불완료(주문취소)
                    </th>
                    <th
                      colSpan={3}
                      className="border-r border py-2 border-primary-grey"
                    >
                      총 환불완료(반품)
                    </th>
                    <th
                      colSpan={2}
                      className="border-r border-r-secondary-grey border py-2 border-primary-grey"
                    >
                      불량접수
                    </th>
                    <th
                      colSpan={3}
                      className="border bg-[#fff500] py-2 border-primary-grey"
                    >
                      총 매출 현황
                    </th>
                  </>
                )}
              </tr>
              <tr className="bg-input-grey">
                <th className="border py-4 border-primary-grey">상품번호</th>
                <th className="border border-primary-grey">카테고리</th>
                <th className="border border-primary-grey">상품 그룹명</th>
                <th className="border w-48 border-primary-grey">상품명</th>
                <th className="border-r border border-r-[#7a7a7a] px-4 border-primary-grey">
                  REF(상품코드)
                </th>
                {isThirdTab ? null : (
                  <>
                    <th className="border px-2 border-primary-grey">
                      LOT 수동 등록
                    </th>
                    <th className="border px-2 border-primary-grey">
                      스마트팩토리
                      <br />
                      연동
                    </th>
                    <th className="border px-2 border-primary-grey">
                      총 입고수량
                    </th>
                    <th className="border px-2 border-primary-grey">
                      자동(재고)
                    </th>
                    <th className="border px-2 border-primary-grey">
                      수동(재고)
                    </th>
                    <th className="border px-2 border-primary-grey">
                      수동(원데이몰)
                    </th>
                    <th className="border px-2 border-primary-grey">
                      불량재고
                    </th>
                    <th className="border px-2 border-primary-grey">
                      기타 출고
                    </th>
                    <th className="border px-2 border-primary-grey">
                      총 출고수량
                    </th>
                    <th className="border px-2 border-primary-grey">
                      (+) 조정수량
                    </th>
                    <th className="border px-2 border-primary-grey">
                      (-) 조정수량
                    </th>
                    <th className="border px-2 border-primary-grey">
                      총 조정수량
                    </th>
                  </>
                )}

                {isSecondTab && (
                  <>
                    <th className="border py-2 px-6 border-primary-grey">
                      원가
                    </th>
                    <th className="border px-2 py-2 border-primary-grey">
                      정상 판매가
                    </th>
                    <th className="border px-4 py-2 border-primary-grey">
                      할인률
                    </th>
                    <th className="border py-2 px-2 border-primary-grey">
                      할인 판매가
                    </th>
                    <th className="border py-2 px-2 border-primary-grey">
                      총 판매수량
                      <br />
                      (구매확정)
                    </th>
                    <th className="border px-2 py-2 border-primary-grey">
                      총 결제금액
                    </th>
                    <th className="border px-2 py-2 border-primary-grey">
                      총 원가 금액
                    </th>
                    <th className="border px-4 py-2 border-primary-grey">
                      원가대비
                      <br />
                      마진율
                    </th>
                    <th className="border px-4 py-2 border-primary-grey">
                      총 환불수량
                      <br />
                      (주문취소)
                    </th>
                    <th className="border px-2 py-2 border-primary-grey">
                      총 주문취소
                      <br />
                      환불금액
                    </th>
                    <th className="border px-3 py-2 border-primary-grey">
                      결제금액
                      <br />
                      대비 환불율
                    </th>
                    <th className="border px-3 py-2 border-primary-grey">
                      총 환불수량
                      <br />
                      (반품완료)
                    </th>
                    <th className="border px-3 py-2 border-primary-grey">
                      총 반품완료
                      <br />
                      환불금액
                    </th>

                    <th className="border px-3 py-2 border-primary-grey">
                      결제금액
                      <br />
                      대비 환불율
                    </th>
                    <th className="border px-3 py-2 border-primary-grey">
                      불량수량
                      <br />
                      (불량교환)
                    </th>
                    <th className="border border-r border-r-secondary-grey px-3 py-2 border-primary-grey">
                      총 판매수량
                      <br />
                      대비 불량율
                    </th>
                    <th className="border px-4 bg-[#fff500] py-2 border-primary-grey">
                      총 결제금액
                    </th>
                    <th className="border px-4 bg-[#fff500] py-2 border-primary-grey">
                      총 환불금액
                    </th>
                    <th className="px-4 bg-[#fff500] border  py-2 border-primary-grey">
                      총 매출금액
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              <tr className="text-center border-t-2 border-b-2 font-bold border-[#7a7a7a] bg-[#d9fba5]">
                <td
                  colSpan={6}
                  className="border border-r border-r-[#7a7a7a] border-primary-grey py-1.5"
                >
                  [전체] 총 계
                </td>
                {isThirdTab ? null : (
                  <>
                    <td className="border border-primary-grey">40</td>
                    <td className="border border-primary-grey">240</td>
                    <td className="border border-primary-grey">280</td>
                    <td className="border border-primary-grey">50</td>
                    <td className="border border-primary-grey">50</td>
                    <td className="border border-primary-grey">100</td>
                    <td className="border border-primary-grey">30</td>
                    <td className="border border-primary-grey">10</td>
                    <td className="border border-primary-grey">240</td>
                    <td className="border border-primary-grey">20</td>
                    <td className="border border-primary-grey">35</td>
                    <td className="border border-primary-grey">-15</td>
                    <td className="border-r border border-r-[#7a7a7a] border-primary-grey">
                      15
                    </td>
                  </>
                )}

                {isSecondTab && (
                  <>
                    <td className="border py-2 border-primary-grey">40,000</td>
                    <th className="border py-2 border-primary-grey">200,000</th>
                    <td className="border py-2 border-primary-grey">할인률</td>
                    <td className="border py-2 border-primary-grey">5%</td>
                    <td className="border py-2 border-primary-grey">90,000</td>
                    <td className="border py-2 border-primary-grey">200</td>
                    <td className="border py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="border py-2 border-primary-grey">
                      4,000,000
                    </td>
                    <td className="border py-2 border-primary-grey">736%</td>
                    <td className="border py-2 border-primary-grey">50</td>
                    <td className="border py-2 border-primary-grey">
                      4,750,000
                    </td>
                    <td className="border py-2 border-primary-grey">16%</td>
                    <td className="border py-2 border-primary-grey">60</td>

                    <td className="border py-2 border-primary-grey">
                      3,300,000
                    </td>
                    <td className="border py-2 border-primary-grey">15%</td>
                    <td className="border border-r border-r-secondary-grey py-2 border-primary-grey">
                      30
                    </td>

                    <td className="border  text-dark-red py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="border  text-dark-red py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="  border text-dark-red  py-2 border-primary-grey">
                      21,400,000
                    </td>
                  </>
                )}
              </tr>
              {row.map((item) => (
                <tr key={item.a} className="text-center border-[#7a7a7a]">
                  <td className="border border-primary-grey px-6">{item.a}</td>
                  <td className="border border-primary-grey px-2.5">
                    {item.b}
                  </td>
                  <td className="border border-primary-grey px-2.5">
                    {item.c}
                  </td>
                  <td className="border border-primary-grey w-56 py-1.5 px-2.5">
                    {item.d}
                  </td>
                  <td className="border border-primary-grey w-56 px-2.5">
                    {item.e}
                  </td>
                  <td className="border border-r border-r-[#7a7a7a] px-2.5 border-primary-grey">
                    {item.f}
                  </td>
                  {isThirdTab ? null : (
                    <>
                      <td className="border border-primary-grey px-2.5">
                        {item.g}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.h}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.i}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.j}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.k}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.l}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.m}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.n}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.o}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.p}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.q}
                      </td>
                      <td className="border border-primary-grey px-2.5">
                        {item.r}
                      </td>
                      <td className="border-r font-bold border border-r-[#7a7a7a] px-2.5 border-primary-grey">
                        {item.s}
                      </td>
                    </>
                  )}

                  {isSecondTab && (
                    <>
                      <td className="border py-2 border-primary-grey">
                        40,000
                      </td>
                      <th className="border py-2 border-primary-grey">
                        200,000
                      </th>
                      <td className="border py-2 border-primary-grey">
                        할인률
                      </td>
                      <td className="border py-2 border-primary-grey">5%</td>
                      <td className="border py-2 border-primary-grey">
                        90,000
                      </td>
                      <td className="border py-2 border-primary-grey">200</td>
                      <td className="border py-2 border-primary-grey">
                        29,450,000
                      </td>
                      <td className="border py-2 border-primary-grey">
                        4,000,000
                      </td>
                      <td className="border py-2 border-primary-grey">736%</td>
                      <td className="border py-2 border-primary-grey">50</td>
                      <td className="border py-2 border-primary-grey">
                        4,750,000
                      </td>
                      <td className="border py-2 border-primary-grey">16%</td>
                      <td className="border py-2 border-primary-grey">60</td>

                      <td className="border py-2 border-primary-grey">
                        3,300,000
                      </td>
                      <td className="border py-2 border-primary-grey">15%</td>
                      <td className="border py-2 border-r border-r-secondary-grey">
                        30
                      </td>

                      <td className="border  font-bold text-dark-red py-2 border-primary-grey">
                        29,450,000
                      </td>
                      <td className="border font-bold text-dark-red py-2 border-primary-grey">
                        29,450,000
                      </td>
                      <td className=" border font-bold text-dark-red  py-2 border-primary-grey">
                        21,400,000
                      </td>
                    </>
                  )}
                </tr>
              ))}
              <tr className="text-center border font-bold bg-[#EDEDED]">
                <td
                  colSpan={6}
                  className="border border-r border-r-[#7a7a7a] border-primary-grey py-1.5"
                >
                  [현재 Page] 총 계
                </td>
                {isThirdTab ? null : (
                  <>
                    <td className="border border-primary-grey">40</td>
                    <td className="border border-primary-grey">240</td>
                    <td className="border border-primary-grey">280</td>
                    <td className="border border-primary-grey">50</td>
                    <td className="border border-primary-grey">50</td>
                    <td className="border border-primary-grey">100</td>
                    <td className="border border-primary-grey">30</td>
                    <td className="border border-primary-grey">10</td>
                    <td className="border border-primary-grey">240</td>
                    <td className="border border-primary-grey">20</td>
                    <td className="border border-primary-grey">35</td>
                    <td className="border border-primary-grey">-15</td>
                    <td className="border-r border border-r-[#7a7a7a] border-primary-grey">
                      15
                    </td>
                  </>
                )}

                {isSecondTab && (
                  <>
                    <td className="border py-2 border-primary-grey">40,000</td>
                    <th className="border py-2 border-primary-grey">200,000</th>
                    <td className="border py-2 border-primary-grey">할인률</td>
                    <td className="border py-2 border-primary-grey">5%</td>
                    <td className="border py-2 border-primary-grey">90,000</td>
                    <td className="border py-2 border-primary-grey">200</td>
                    <td className="border py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="border py-2 border-primary-grey">
                      4,000,000
                    </td>
                    <td className="border py-2 border-primary-grey">736%</td>
                    <td className="border py-2 border-primary-grey">50</td>
                    <td className="border py-2 border-primary-grey">
                      4,750,000
                    </td>
                    <td className="border py-2 border-primary-grey">16%</td>
                    <td className="border py-2 border-primary-grey">60</td>

                    <td className="border py-2 border-primary-grey">
                      3,300,000
                    </td>
                    <td className="border py-2 border-primary-grey">15%</td>
                    <td className="border py-2 border-r border-r-secondary-grey border-primary-grey">
                      30
                    </td>

                    <td className="border font-bold text-dark-red py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="border  font-bold text-dark-red py-2 border-primary-grey">
                      29,450,000
                    </td>
                    <td className="  border font-bold text-dark-red  py-2 border-primary-grey">
                      21,400,000
                    </td>
                  </>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatisticsTable;
